<template>
  <div data-cy="base-information-modal">
    <v-row justify="center">
      <v-dialog v-model="value" persistent width="auto ">
        <v-card>
          <v-card-title class="headline background">{{ title }}</v-card-title>
          <v-divider></v-divider>
          <v-layout column justify-center align-center>
            <v-card-text>{{ content }}</v-card-text>
          </v-layout>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="acknowledge()"
              data-cy="btn-okay"
              >{{ i18n.t("_Okay") }}</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import i18n from "../helper/i18n"
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    path: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      i18n: i18n
    }
  },
  methods: {
    acknowledge() {
      this.$emit("input", false);
      this.$emit("acknowledged");
      if (this.path !== undefined) {
        this.$router.push(this.path);
      }
    },
  },
};
</script>
